/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { memo, useState, useContext, useRef } from 'react';
import PropTypes from 'prop-types';
import {
  ShellV2,
  Button,
  Icon,
  Notification,
  Image,
  Space,
  Conditional,
  OpenHelpCenter,
} from '@cashfree-intl/coherent';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';

import { useClickOutSideGen } from 'utils/hooks';
import {
  DAY_ZERO_SHOPIFY_MODAL,
  DAY_ZERO_SHOPIFY_PROFILE_ACTIVATION,
  LOGO_MAPPING,
  PG_DASHBOARD_SUMMARY_PATH,
  PROD,
  TEST,
} from 'utils/constants';
import { basename } from 'store';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { fetchGammaTokenAction } from 'containers/LandingPage/actions';
import NotificationPopover from 'containers/Notification/NotificationPopover';
import NotificationBar from 'containers/Notification/NotificationBar';
import { identifyCampaign } from 'containers/ProductTour/helper';

import {
  isICICIDashboard,
  isLKDashboard,
  isIDFCDashboard,
  isYesMerchant,
  getItemFromLocalStorage,
  isAxisDashboard,
  getFlowwiseDefaultMenuPath,
} from 'utils/common';
import Analytics from 'utils/analytics';
import EVENTS from 'constants/analytics';

import cFIDFCLogo from 'images/cf-idfc-logo.svg';
import { createStructuredSelector } from 'reselect';
import { MerchantDetailsContext } from 'contexts/MerchantDetailsContext';
import { MerchantContext } from 'contexts/MerchantContext';
// import { UserDetailsContext } from 'contexts/UserDetailsContext';
import { INSIGHTS_AI_PATH } from 'containers/FlowwiseLayout/constants';
import InsightsAIPopupComponent from './components/InsightsAIPopup';
import { menuItems, keyKeyMapping } from './constants';
import { StyledLogoDiv, StyledPopup, StyledTooltipHeader } from './styled';

function BaseLayout({ children, fetchGammaToken }) {
  const [searchParams] = useSearchParams();
  const [isTest, setIsTest] = useState(false);
  const [showInsightsAiIcon, setInsightsAiIconDisplay] = useState(false);

  const { togglePanel, showPanel } = useContext(Notification.Context);
  const {
    productStatus: merchantProductStatus,
    productFruitCampaigns,
    isMerchantImportEnabled,
  } = useContext(MerchantContext);
  const { merchantDetails, routerStatus } = useContext(MerchantDetailsContext);
  // const { userDetails } = useContext(UserDetailsContext); TODO: will un-comment once partners' issue of showing actual partners information is figured out.
  const dayZeroShopifyModal = identifyCampaign(
    productFruitCampaigns?.campaigns,
    DAY_ZERO_SHOPIFY_MODAL,
  );

  const dayZeroShopifyProfileActivation = identifyCampaign(
    productFruitCampaigns?.campaigns,
    DAY_ZERO_SHOPIFY_PROFILE_ACTIVATION,
  );

  const dayZeroEnabled = dayZeroShopifyModal || dayZeroShopifyProfileActivation;

  const accountDetails = {
    accountName: merchantDetails.merchantName,
    accountEmailId: merchantDetails.merchantEmail,
  };

  const navigate = useNavigate();
  const popover = useRef();
  useClickOutSideGen(popover, () => {
    if (showPanel) {
      togglePanel();
    }
  });

  const switchEnvAndNavigate = () => {
    const queryParam = isTest ? '?env=prod' : '?env=test';
    navigate(`${basename}landing${queryParam}`);
    setIsTest(!isTest);
  };
  const fetchGammaTokenAndNavigate = switchEnvNavigate => {
    fetchGammaToken({
      cb: () => {
        if (!isTest && getItemFromLocalStorage('gammaToken')) {
          switchEnvNavigate();
        }
      },
    });
  };

  const navigateToInsightsAI = () => {
    Analytics.trackEventWithNewNomenclature({
      eventName: EVENTS.INSIGHTS_AI.FLOWWISE_WEBAPP_V2_CLICKED,
      eventProperties: { source: 'global_header' },
    });
    navigate(
      `${basename}${envObj.FLOWWISE_BASE_PATH}${INSIGHTS_AI_PATH}?env=${
        isTest ? TEST : PROD
      }`,
    );
  };

  const toggleEnv = () => {
    if (!isTest && !getItemFromLocalStorage('gammaToken')) {
      fetchGammaTokenAndNavigate(switchEnvAndNavigate);
    } else {
      switchEnvAndNavigate();
    }
  };
  const renderLogo = () => {
    if (isYesMerchant()) {
      return (
        <div className="image-wrapper">
          <div className="merchant-img">
            <Icon name="cf-logo" />
          </div>
          <div className="divider" />
          <Image src={LOGO_MAPPING.YESMERCHANT} className="yes-logo" />
        </div>
      );
    }
    if (isICICIDashboard()) {
      return (
        <div className="merchant-img">
          <Image src={LOGO_MAPPING.ICICIMERCHANT} className="icici-logo" />
        </div>
      );
    }
    if (isLKDashboard()) {
      return (
        <div className="image-wrapper">
          <div className="merchant-img">
            <Icon name="cf-logo" />
          </div>
          <div className="divider" />
          <Image src={LOGO_MAPPING.LENDINGKARTMERCHANT} className="lk-logo" />
        </div>
      );
    }
    if (isIDFCDashboard()) {
      return (
        <div className="image-wrapper">
          <Image src={cFIDFCLogo} />
        </div>
      );
    }
    if (isAxisDashboard())
      return (
        <Image src={LOGO_MAPPING.AXISEASYPAYPLUS_WHITE} className="axis-logo" />
      );
    return (
      <StyledPopup
        content={
          <StyledTooltipHeader color="bodyLight">
            Cashfree Payments
          </StyledTooltipHeader>
        }
        position="bottom"
        basic
        trigger={
          <div className="merchant-img">
            <Icon name="cf-logo" />
          </div>
        }
      />
    );
  };

  const getXSLogoKey = () => {
    if (isICICIDashboard()) {
      return 'ICICIMERCHANT_XS';
    }
    if (isLKDashboard()) {
      return 'LENDINGKARTMERCHANT_XS';
    }
    return 'XS';
  };

  const envObj = process.env;

  const redirectToProduct = val => {
    if (keyKeyMapping[val.key] === 'PG') {
      navigate(
        `${basename}${PG_DASHBOARD_SUMMARY_PATH}${isTest ? '?env=test' : ''}`,
      );
    }
    if (keyKeyMapping[val.key] === 'CSP') {
      window.location.href = `${envObj.PAYOUTS_BASE_PATH}?env=${
        isTest ? TEST : PROD
      }&productCode=${keyKeyMapping[val.key]}`;
    }
    if (keyKeyMapping[val.key] === 'CAC') {
      window.location.href = `${envObj.CAC_BASE_PATH}?env=${
        isTest ? TEST : PROD
      }`;
    }
    if (keyKeyMapping[val.key] === 'LRS') {
      window.location.href = `${envObj.LRS_BASE_PATH}?env=${
        isTest ? TEST : PROD
      }`;
    }
    if (keyKeyMapping[val.key] === 'SBC') {
      window.location.href = `${envObj.SBC_BASE_PATH}?env=${
        searchParams.get('env') === TEST ? TEST : PROD
      }`;
    }
    if (keyKeyMapping[val.key] === 'VRS') {
      window.location.href = `${envObj.VRS_BASE_PATH}?env=${
        isTest ? TEST : PROD
      }`;
    }
    if (keyKeyMapping[val.key] === 'EPOS') {
      navigate(`${basename}pg/softpos?env=${isTest ? TEST : PROD}`);
    }

    if (keyKeyMapping[val.key] === 'CES') {
      navigate(`${basename}pg/easy-split/vendors?env=${isTest ? TEST : PROD}`);
    }

    if (keyKeyMapping[val.key] === 'FLOWWISE') {
      navigate(
        `${basename}${envObj.FLOWWISE_BASE_PATH}${getFlowwiseDefaultMenuPath(
          routerStatus,
        )}${isTest ? '?env=test' : ''}`,
      );
    }
  };

  const redirectEnv = () => {
    if (searchParams.get('env') === TEST && isTest === false) {
      setIsTest(!isTest);
    }
  };

  const goToDevelopers = () => {
    setTimeout(() => {
      window.location.href = `${process.env.COMMON_BASE_PATH}/developers?env=${
        isTest ? TEST : PROD
      }`;
    }, 50);
  };

  const onHelpCenterClick = () => {
    OpenHelpCenter.redirectToHelpCenter(window.location.pathname);
  };

  redirectEnv();

  return (
    <>
      <ShellV2>
        <ShellV2.GlobalHeader>
          <ShellV2.GlobalHeader.LeftContainer>
            <StyledLogoDiv>
              <Link to={`${basename}landing?env=${isTest ? TEST : PROD}`}>
                {renderLogo()}
                <Image
                  className="visible_xs"
                  src={LOGO_MAPPING[getXSLogoKey()]}
                />
              </Link>
            </StyledLogoDiv>
            <Conditional if={!dayZeroEnabled && !isMerchantImportEnabled}>
              <ShellV2.GlobalHeader.LeftContainer.ProductDropdown
                selected={{
                  key: 'common',
                  value: false,
                  hasMultipleAccounts: false,
                }}
                activationDetails={merchantProductStatus}
                isTest={isTest}
                handleProductNameClick={val => {
                  const prodName = keyKeyMapping[val.key];
                  redirectToProduct(val);
                  Analytics.track(EVENTS.SHELL_V2.NAV_BENTO_CLICKED, {
                    Product_Selected: keyKeyMapping[val.key],
                    Type:
                      !isTest && merchantProductStatus[prodName] === 'APPROVED'
                        ? 'access'
                        : 'discover',
                  });
                }}
              />
            </Conditional>
          </ShellV2.GlobalHeader.LeftContainer>
          <ShellV2.GlobalHeader.RightContainer>
            <ShellV2.GlobalHeader.RightContainer.Buttons>
              <>
                <Space alignItems="center" gap={1}>
                  <Conditional if={!dayZeroEnabled}>
                    <Conditional
                      if={showInsightsAiIcon && !isMerchantImportEnabled}
                    >
                      <InsightsAIPopupComponent
                        navigateToInsightsAI={navigateToInsightsAI}
                      />
                    </Conditional>
                    <Button
                      secondary
                      size="small"
                      className="btn-text fill-btn"
                      onClick={goToDevelopers}
                    >
                      Developers
                    </Button>
                    <Button
                      secondary
                      size="small"
                      className="btn-text fill-btn"
                      onClick={toggleEnv}
                    >
                      Switch to {isTest ? `Prod` : `Test`}
                    </Button>
                  </Conditional>
                </Space>
              </>
            </ShellV2.GlobalHeader.RightContainer.Buttons>
            <NotificationPopover isShellV2 />
            <ShellV2.GlobalHeader.RightContainer.HelpCenter
              handleHelpCenterClick={onHelpCenterClick}
            />
            <ShellV2.GlobalHeader.RightContainer.Settings
              handleSettingsClick={async () => {
                await Analytics.track(EVENTS.SHELL_V2.NAV_SETTINGS_CLICKED, {
                  Response: 'click',
                });
                window.location.href = `${
                  process.env.COMMON_BASE_PATH
                }/settings`;
              }}
            />
            <ShellV2.GlobalHeader.RightContainer.Profile
              profileMenuOptions={menuItems}
              merchantAccountDetails={
                accountDetails.accountEmailId
                  ? accountDetails
                  : { accountName: '', accountEmailId: '' }
              }
              handleManageAccountClick={async () => {
                await Analytics.track(
                  EVENTS.SHELL_V2.NAV_PROFILE_MANAGE_ACCOUNT_CLICKED,
                  {
                    Response: 'click',
                  },
                );
                window.location.href = `${
                  process.env.COMMON_BASE_PATH
                }/profile/my-information`;
              }}
              hideOldNavigationSwitch
            />
          </ShellV2.GlobalHeader.RightContainer>
          {isTest && (
            <ShellV2.GlobalHeader.Banner.TextBanner bannerText="Test Environment" />
          )}
        </ShellV2.GlobalHeader>
        <Conditional if={!dayZeroEnabled}>
          <NotificationBar />
        </Conditional>
        <ShellV2.MainLayout>
          <ShellV2.MainLayout.MainContent style={{ padding: '0rem' }}>
            {children({
              isTest,
              toggleEnv,
              setIsTest,
              setInsightsAiIconDisplay,
            })}
          </ShellV2.MainLayout.MainContent>
        </ShellV2.MainLayout>
      </ShellV2>
    </>
  );
}

BaseLayout.propTypes = {
  children: PropTypes.any.isRequired,
  fetchGammaToken: PropTypes.string,
};

const mapStateToProps = createStructuredSelector({});
const mapDispatchToProps = dispatch => ({
  fetchGammaToken: data => dispatch(fetchGammaTokenAction(data)),
});

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withConnect,
  memo,
)(BaseLayout);
